<template>
  <label>
    <input
      :id="inputId"
      type="checkbox"
      class="h-3 w-3 transition duration-150 ease-in-out"
      :checked="value"
      :disabled="disabled"
      @change="onChange"
    />
    <slot />
  </label>
</template>

<script>
import { isArray } from 'util'
import { computed } from '@vue/composition-api'

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
    },
    disabled: {
      default: false,
    },
    inputId: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const onChange = (event) => {
      event.stopPropagation()
      const isChecked = event.target.checked
      emit('change', isChecked)
    }
    return {
      emit,
      onChange,
    }
  },
}
</script>
